import { Member, MemberRole } from '@stytch/vanilla-js'
import { Role } from '@/service-library/hooks/auth-user'

const HIDDEN_ROLE_IDS = ['stytch_member', 'stytch_admin']

export function isRoleVisibleInUI(roleId: string) {
  return !HIDDEN_ROLE_IDS.includes(roleId) && !roleId.startsWith('PD ')
}

export const DEFAULT_USER_ROLE = {
  id: 'User',
  description: 'Can view and manage documents this user has uploaded.',
  order: 0,
  is_assignable: true,
}

export function getHighestRole(
  stytchRoles: MemberRole[],
  rolesMap: Map<string, Role>,
) {
  let highestRole: Role = DEFAULT_USER_ROLE
  stytchRoles.forEach((memberRole) => {
    if (!isRoleVisibleInUI(memberRole.role_id)) return
    const role = rolesMap.get(memberRole.role_id)
    if (role && role.order > highestRole.order) {
      highestRole = role
    }
  })
  return highestRole
}

type RemoveUserPermissionResult = {
  canRemoveUser: boolean
  tooltip: string
}

export function getRemoveUserPermission({
  loggedInMember,
  targetMember,
  rolesMap,
}: {
  loggedInMember: Member
  targetMember: Member
  rolesMap: Map<string, Role>
}): RemoveUserPermissionResult {
  if (loggedInMember.member_id === targetMember.member_id) {
    return {
      canRemoveUser: false,
      tooltip: 'You cannot remove your own user.',
    }
  }

  const targetRole = getHighestRole(targetMember.roles, rolesMap)
  if (targetRole.id === 'Prime Admin') {
    return {
      canRemoveUser: false,
      tooltip: 'Prime Admin users cannot be removed.',
    }
  }

  const loggedInRole = getHighestRole(loggedInMember.roles || [], rolesMap)
  const canRemoveUser = loggedInRole.order >= targetRole.order

  return {
    canRemoveUser,
    tooltip: canRemoveUser
      ? 'Remove user'
      : 'You must have a higher role to remove this user.',
  }
}
